import type { TFunction } from 'i18next';
import type { OfferOutcome } from '@/entities/order';

/** Localised outcome of an offer: accepted, a reason name, or the two fallbacks. */
export function outcomeLabel(t: TFunction<'orders'>, outcome: OfferOutcome): string {
  if (outcome.kind === 'accepted') return t('offers.outcome.accepted');
  if (outcome.kind === 'reason' && outcome.reason)
    return t(`offers.${outcome.reason.labelKey}`);
  return t(
    outcome.kind === 'declined'
      ? 'offers.outcome.declined'
      : 'offers.outcome.undelivered',
  );
}

/**
 * A value to print, or null when it is blank — cpanel's `value || fallback`,
 * minus the surprise of treating a legitimate number as missing.
 */
export function presentText(value: string | number | null | undefined): string | null {
  if (value == null || value === 0) return null;
  const text = String(value).trim();
  return text === '' ? null : text;
}

const SHORT_ID_LENGTH = 6;

/**
 * A courier id for display. UUIDs are cut to their LAST characters: they are
 * v7, so the leading part is a timestamp shared by couriers created together
 * (`01a0d219-…` on every id) and only the tail tells them apart.
 */
export function shortCourierId(id: string | number | null | undefined): string | null {
  const text = presentText(id);
  if (text === null) return null;
  return text.length > SHORT_ID_LENGTH ? text.slice(-SHORT_ID_LENGTH) : text;
}
